<template>
  <b-row class="grab">
    <b-col class="col-main-pad">
      <b-row>
        <b-col lg="12" class="col-head-activity">
          <font-awesome-icon icon="brain" />&nbsp; Configurar Memorama
        </b-col>
        <b-col lg="12">
          <b-form-group>
            <label for="name">Instrucciones de la Actividad</label>
            <b-form-textarea
              v-model="instrucciones"
              placeholder="Ingrese las Instrucciones para Realizar la Actividad"
              rows="2"
              max-rows="3"
            ></b-form-textarea>
          </b-form-group>
        </b-col>

        <b-col lg="12">
          <b-form-group>
            <label for="name">No. de Cartas</label>
            <b-form-select
              :value="defaultSelected"
              id="cartasNumero"
              class="border-visible"
              :options="noCartas"
              @change="onChangeCartas($event)"
              variant="primary"
            >
              <template slot="first">
                <option :value="null" disabled>Seleccione un Número</option>
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>

        <b-col lg="3" v-for="(carta,index) in cartasSelected" :key="carta.index">
          <b-card show-header show-footer>
            <div>
              <p>
                <strong>Vista</strong>
                <i class="icon-close close-style" @click="removeCarta(index)"></i>
              </p>
              <b-form-select
                :value="carta.tipo"
                :id="`memoramaTipo-${carta.id}`"
                :options="tipos"
                :name="`memoramaTipo-${carta.id}`"
                @change="onChangeTipo($event, carta)"
              ></b-form-select>
            </div>
            <div v-if="carta.tipo == 1" style="height: 185px;">
              <b-form-textarea
                v-model="carta.data"
                placeholder="Agregue Texto"
                rows="8"
                max-rows="8"
                class="textarea"
              ></b-form-textarea>
            </div>
            <div v-if="carta.tipo == 2">
              <button
                type="button"
                class="btn btn-primary btn-select-recurso"
                @click="openModalRecursos('IMAGEN',carta,'vista')"
              >Seleccionar un Recurso</button>
              <div v-if="carta.data != null" class="preview">
                <b-img thumbnail fluid :src="$root.setUrlFile(carta.data)" alt="Imagen" style="width: 160px; height: 160px;"></b-img>
              </div>
            </div>
            <div slot="footer">
              <p>
                <strong>Agregar audio</strong>
              </p>
              <div>
                <button
                  type="button"
                  class="btn btn-primary btn-select-recurso"
                  @click="openModalRecursos('AUDIO',carta,'audio')"
                >Seleccionar un Audio</button>
                <div v-if="carta.audio != null" class="preview">
                  <audio class="audio-thumb-card" controls="controls" autobuffer="autobuffer">
                    <source :src="$root.setUrlFile(carta.audio)" />
                  </audio>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col lg="12" style="text-align: right;">
          <button type="button" class="btn btn-primary" @click="newCarta">
            <i class="icon-plus"></i>&nbsp;Nueva Carta
          </button>
        </b-col>
      </b-row>
    </b-col>
    <!-- componente de botón de opciones del elemento  -->
    <options-element :index-element="idElement" :index-column="idColumn"></options-element>
    <!-- Modal recursos -->
    <ModalRecursos
      :showModal="showModal"
      v-on:closeModal="showModal = $event"
      :typeRecurso="typeRecurso"
      v-on:data-selected="chooseRecurso($event,seccionSelected)"
    ></ModalRecursos>
  </b-row>
</template>

<script>
var arry = new Array(50);
var noCartas = [];
for (let i = 1; i < arry.length; i++) {
  noCartas.push(i);
}
import ModalRecursos from "@/components/ModalRecursos/";
import OptionsElement from "./OptionsElement";

export default {
  name: "Memorama",
  props: {
    cartas: {
      type: Array,
      default: () => {
        return new Array();
      }
    },
    desc: { type: String },
    idElement: { type: Number },
    idColumn: { type: Number, default: null }
  },
  data() {
    return {
      instrucciones: this.desc,
      defaultSelected: null,
      cartasSelected: this.cartas,
      noCartas: noCartas,
      tipos: [
        { value: null, text: "Seleccione un Tipo", disabled: true },
        { value: 1, text: "Texto" },
        { value: 2, text: "Imagen" }
      ],
      showModal: false,
      typeRecurso: null,
      dataProcessModal: null,
      seccionSelected: ""
    };
  },
  components: {
    ModalRecursos,
    OptionsElement
  },
  methods: {
    onChangeCartas(number) {
      this.cartasSelected = [];
      var cartasArray = new Array(number);
      for (let i = 0; i < cartasArray.length; i++) {
        var cartaData = {
          id: i + 1,
          tipo: null,
          data: null,
          audio: null
        };
        this.cartasSelected.push(cartaData);
      }
      console.log(this.cartasSelected);
    },
    openModalRecursos(tipo, carta, secc) {
      this.typeRecurso = tipo;
      this.showModal = true;
      this.seccionSelected = secc;
      this.dataProcessModal = carta;
    },
    chooseRecurso(e, secc) {
      console.log(e);
      console.log(secc);
      if (secc == "vista") {
        this.dataProcessModal.data = e.file;
      } else {
        this.dataProcessModal.audio = e.file;
      }
    },
    onChangeTipo(value, carta) {
      carta.data = null;
      carta.tipo = value;
    },
    removeCarta(index) {
      this.$swal({
        type: "warning",
        title: "Eliminar una Carta",
        text: `¿Seguro que Deseas Eliminar la Carta No. ${index + 1}?`,
        showCancelButton: true,
        confirmButtonColor: "#285c4d",
        cancelButtonColor: "#aaa",
        confirmButtonText: "Sí, Eliminar",
        cancelButtonText: "No, Cancelar"
      }).then(result => {
        if (result.value) {
          this.cartasSelected.splice(index, 1);
        }
      });
    },
    newCarta() {
      var i = this.cartasSelected.length;
      var cartaData = {
        id: i + 1,
        tipo: null,
        data: null,
        audio: null
      };
      this.cartasSelected.push(cartaData);
    }
  },
  watch: {
    cartasSelected: {
      handler: function(change) {
        this.$store.dispatch("constructor/updateContentElement", {
          indexElement: this.idElement,
          data: change,
          field: "cartas",
          indexColumns: this.idColumn
        });
      },
      deep: true
    },
    instrucciones: function(change) {
      this.$store.dispatch("constructor/updateContentElement", {
        indexElement: this.idElement,
        data: change,
        field: "instrucciones",
        indexColumns: this.idColumn
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.textarea {
  resize: none;
  text-align: center;
  margin-top: 50px;
}
.btn-select-recurso {
  margin-top: 20px;
  width: 100%;
  text-align: center;
}
.preview {
  margin-top: 20px;
  text-align: center;
  height: auto;
}
.img-thumb-card {
  width: 160px;
  height: 160px;
}
.audio-thumb-card {
  width: 100%;
}
</style>